import { StrictMode } from "react";
import ReactDOM from "react-dom";
import domReady from '@wordpress/dom-ready';

import MembershipForm from "./membership-form";

domReady( function () {
const rootElement = document.getElementById("ffb-root");
	const group1 = document.querySelector( '.ffb-membership-form__group1');
	const group2 = document.querySelector( '.ffb-membership-form__group2');
	group1.style.display = 'block';
	group2.style.display = 'none';
ReactDOM.render(
  <StrictMode>
    <MembershipForm />
  </StrictMode>,
  rootElement
);
} );
